import { useEffect, useState } from "react";
import axios from "axios";

// Pantallas favoritas por usuario (la estrella de las tarjetas de los menus). Se guardan en el usuario
// (back /usersFavoritos) y se cachean en localStorage para que la barra lateral salga al instante en cada
// pagina; la barra y las tarjetas comparten la misma lista.
const URL_FAVORITOS = `${process.env.REACT_APP_URL_USERS}Favoritos`;
const MAX = 40;

let lista = null;
let usuario = null;
let pedido = false;
const subs = new Set();

const clave = (uid) => `favoritos:${uid}`;
const hdrs = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

function leerCache(uid) {
  try {
    return JSON.parse(localStorage.getItem(clave(uid))) || [];
  } catch (e) {
    return [];
  }
}

function publicar(nueva) {
  lista = nueva;
  try {
    localStorage.setItem(clave(usuario), JSON.stringify(nueva));
  } catch (e) {
    // sin localStorage solo se pierde el cache
  }
  subs.forEach((f) => f(nueva));
}

export function useFavoritos(user) {
  const uid = user && user.id;
  const [favoritos, setFavoritos] = useState(() => (uid ? (usuario === uid && lista) || leerCache(uid) : []));

  useEffect(() => {
    if (!uid) return undefined;
    if (usuario !== uid) {
      usuario = uid;
      lista = leerCache(uid);
      pedido = false;
    }
    setFavoritos(lista);
    subs.add(setFavoritos);
    if (!pedido) {
      pedido = true;
      axios
        .get(URL_FAVORITOS, hdrs())
        .then((res) => publicar(Array.isArray(res.data) ? res.data : []))
        .catch(() => { pedido = false; });
    }
    return () => { subs.delete(setFavoritos); };
  }, [uid]);

  const guardar = (nueva) => {
    const antes = lista || [];
    publicar(nueva);
    axios.put(URL_FAVORITOS, { favoritos: nueva }, hdrs()).catch(() => publicar(antes));
  };

  const esFavorito = (href) => favoritos.some((f) => f.href === href);
  const alternar = ({ label, icon, color, href }) => {
    const actual = lista || [];
    if (actual.some((f) => f.href === href)) guardar(actual.filter((f) => f.href !== href));
    else if (actual.length < MAX) guardar([...actual, { label, icon: icon || "", color: color || "", href }]);
  };
  const quitar = (href) => guardar((lista || []).filter((f) => f.href !== href));

  return { favoritos, esFavorito, alternar, quitar };
}
